<template>
  <v-row>
    <v-col class="py-0 max-w-50px">
      <v-checkbox
        class="mr-5"
        v-model="checkbox"
        :disabled="disabled"
        @change="onCheckboxClicked($event)"
      ></v-checkbox>
    </v-col>
    <v-col class="py-0">
      <paragraph><slot></slot></paragraph>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="localDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="localDate"
            :label="label"
            :disabled="!checkbox"
            readonly
            v-on="on"
            style="max-width: 240px;"
            class="mt-0 pt-0"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="localDate"
          first-day-of-week="1"
          :locale="selectedLocale"
          no-title
          scrollable
          color="primary"
          class="pa-2"
        >
          <div class="full-width">
            <div class="d-flex justify-space-between">
              <v-btn outlined color="primary" @click="menu = false">
                {{ $t("message.common.cancel") }}
              </v-btn>
              <v-spacer />
              <v-btn color="primary" @click="onSaveDate">
                {{ $t("message.common.ok") }}
              </v-btn>
            </div>
          </div>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import Paragraph from "@/components/ui/Paragraph.vue";

export default {
  name: "DatePickerWithCheckbox",
  components: { Paragraph },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkbox: false,
      localDate: "",
      menu: false
    };
  },
  computed: {
    ...mapState({
      selectedLocale: state => state.settings.selectedLocale
    })
  },
  watch: {
    date(newVal) {
      this.localDate = newVal;
    },
    checked(newVal) {
      this.checkbox = newVal;
    }
  },
  methods: {
    onCheckboxClicked(val) {
      this.$emit("update:checked", val);
      if (!val) {
        this.$emit("update:date", "");
      }
    },
    onSaveDate() {
      this.$refs.menu.save(this.localDate);
      this.$emit("update:date", this.localDate);
    }
  }
};
</script>
